import { Component, Input, TemplateRef } from '@angular/core';
import { ButtonColors } from '@ed---interne/ng-uui-components';

import { ConcessionControl } from 'src/app/core/models/concession-control.model';

@Component({
    selector: 'app-studies',
    templateUrl: './studies.component.html',
    styleUrls: ['./studies.component.scss'],
})
export class StudiesComponent {
    @Input() ccStudies: ConcessionControl[] = [];
    @Input() ccStudyHeaderTemplate!: TemplateRef<any>;
    @Input() ccStudyBodyTemplate!: TemplateRef<any>;

    @Input() cracStudies: any[] = [];
    @Input() cracStudyHeaderTemplate!: TemplateRef<any>;
    @Input() cracStudyBodyTemplate!: TemplateRef<any>;

    @Input() cracMaps: any[] = [];
    @Input() cracmapHeaderTemplate!: TemplateRef<any>;
    @Input() cracmapBodyTemplate!: TemplateRef<any>;

    public buttonColors = ButtonColors;
    public goToTableau() {
        const url = 'https://sso.online.tableau.com';
        window.open(url, '_blank');
    }
}
